import { Pipe } from "@angular/core";

@Pipe({
    name: 'groupBy',
    standalone: true,
})
export class GroupByPipe {
    async transform(value: Array<any>, key: string, pipeTransform: string = ''): Promise<Record<string, any[]>> {
        if (!value) return value;
        if (pipeTransform) {
            if (pipeTransform.includes('|')) {
                const pipeName = pipeTransform.split('|')[1].trim().split(':')[0].trim();	
                const pipeArgs = pipeTransform.split('|')[1].trim().split(':')[1].trim().split(',').map(arg => arg.trim());
                var pipeModule = await import('@angular/common');
                const pipeClass = (pipeModule as Record<string, any>)[pipeName.substring(0, 1).toUpperCase() + pipeName.substring(1) + 'Pipe'];
                if (!pipeClass) {
                    throw new Error(`Pipe ${pipeName} not found.`);
                }
                const pipe = new pipeClass();
                if (pipe) {
                    return value.reduce((acc, curr) => {
                        if (curr[key] !== undefined && curr[key] !== null) {
                            const transformedKey = pipe?.transform(curr[key], ...pipeArgs);
                            if (transformedKey === undefined || transformedKey === null) {
                                throw new Error(`Invalid transformation for key: ${curr[key]}`);
                            }
                            if (acc[transformedKey]) {
                                acc[transformedKey].push(curr);
                            } else {
                                acc[transformedKey] = [curr];
                            }
                            return acc;
                        }
                    }, {});
                }
                
            }
        }

        return value.reduce((acc, curr) => {
            if (acc[curr[key]]) {
                acc[curr[key]].push(curr);
            }
            else {
                acc[curr[key]] = [curr];
            }
            return acc;
        }, {});
    }
}